import { render, staticRenderFns } from "./SortingList.vue?vue&type=template&id=25c36c69&scoped=true&lang=pug&"
import script from "./SortingList.vue?vue&type=script&lang=js&"
export * from "./SortingList.vue?vue&type=script&lang=js&"
import style0 from "./SortingList.vue?vue&type=style&index=0&id=25c36c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c36c69",
  null
  
)

export default component.exports